import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-backdrop"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loadingio-spinner-spinner-uv9rv5zs0wc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ldio-7tt8397p6dh" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "loading-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.showLBackDrop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["loader-container-outer", [this.loadingTextContainer ? 'loading-text-container' : '']])
    }, [
      _hoisted_2,
      (this.loadingTextContainer)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(this.loadingMessage), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}